import React from 'react';
import { useLocation } from 'react-router';
import Loader from '../Loader/Loader';
import useStore from '../../store';

const Overlay = () => {
  const loadingPost = useStore((state) => state.loadingPost)
  const {pathname} = useLocation();

  if (!loadingPost && pathname === "/") return null;

  return (
    <div className="overlay">
      <div className="overlay__inner">
        <div className="overlay__content">
          <Loader />
        </div>
      </div>
    </div>

  )
}

export default Overlay;
